import { isNil, isEmpty } from './type'
/**
 * validate轻量封装
 * 简化validate的编写，自动处理callback & error, internalValidate只关注核心逻辑处理以及提示的message
 * @param {Function} internalValidate
 */
export const validate = (internalValidate) => {
  return (rule, value, callback) => {
    const message = internalValidate(value, rule, callback);
    if(isNil(message)) {
      callback()
    } else {
      callback(new Error(message))
    }
  }
}

// 针对老密码的校验
export const oldPasswordValidator = validate(value => {
  if(isEmpty(value)) {
    return '请输入密码'
  }
  return undefined
})


// 针对密码的校验
export const passwordValidator = validate(value => {
  if(isEmpty(value)) {
    return '请输入密码'
  }
  // 6-16个字符，至少一个字母和一个数字
  const reg = /^([a-zA-Z0-9]){6,18}$/
  if(!reg.test(value)) {
    return '请输入6-18个字符'
  }
  return undefined
})

// 针对手机号的校验
export const cellPhoneValidator = validate(value => {
  if(isEmpty(value)) {
    return '请输入手机号或账号'
  }
  return undefined
})

// 手机号校验
export const cellTelValidator = validate(value => {
  if(isEmpty(value)) {
    return '请输入手机号码'
  }
  const reg = /^[1][0-9]{10}$/
  if(!reg.test(value)) {
    return '请输入正确的手机号码'
  }
  return undefined
})